/* eslint-disable import/prefer-default-export */
function numberToCurrency(number) {
  return number.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })
    .replace(/R\$\s?/, '')
    .replace(/,/g, '.')
    .replace(/\.(\d+)$/, ',$1');
}

export { numberToCurrency };
